import React, { useState } from "react";
import styled from "styled-components";
import { useTranslation } from "react-i18next";

const StyledList = styled.ul`
  list-style-type: disc;
`;

const Box = styled.div`
  font-size: 18px !important;
  color: #000 !important;

  @media (max-width: 768px) {
    font-size: 14px !important;
  }
`;
const ReadMoreLess = styled.div`
  display: inline-block;
  text-decoration: underline;
  cursor: pointer;
  margin-top: ${(props) => (props.hasMargin ? "8px" : "0")};
`;

const ATLTinckerpreneurDisclaimer = (props) => {
  const [showAll, setShowAll] = useState(false);
  const { t } = useTranslation();

  return (
    <Box className="w-100 px-3 px-5">
      <h2 className="text-left mb-2 mb-md-4">
        {t("atl_tinkerpreneur.disclaimer_title")}
      </h2>
      <StyledList>
        <li>{t("atl_tinkerpreneur.disclaimer_content_1")}</li>
        {!showAll && (
          <>
            {" "}
            <ReadMoreLess
              onClick={(e) => {
                e.preventDefault();
                setShowAll(true);
              }}
            >
              Read More
            </ReadMoreLess>
          </>
        )}
        {showAll && (
          <>
            <li>{t("atl_tinkerpreneur.disclaimer_content_2")}</li>
            <li>{t("atl_tinkerpreneur.disclaimer_content_3")}</li>
            <li>{t("atl_tinkerpreneur.disclaimer_content_4")}</li>
            <li>{t("atl_tinkerpreneur.disclaimer_content_5")}</li>
            <li>{t("atl_tinkerpreneur.disclaimer_content_6")}</li>
            <ReadMoreLess
              onClick={(e) => {
                e.preventDefault();
                setShowAll(false);
              }}
              hasMargin
            >
              Read Less
            </ReadMoreLess>
          </>
        )}
      </StyledList>
    </Box>
  );
};

export default ATLTinckerpreneurDisclaimer;
